import React, { useState, useEffect } from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

// components
import InputResposta from "../../../../components/Inputs/InputResposta";

//helpers
import formulariovistoria_api from "../../../../api/formulariovistoria_api";
import { showMessage } from "../../../../helpers/message";

export default function EditarRespostaBoletim({ modalVisibilidade, setModalVisibilidade, questaoEditar, setQuestaoEditar, stepFormulario, boletimVistoria, setBoletimVistoria}) {
    const [formularioQuestaoOpcao, setFormularioQuestaoOpcao] = useState(null);
    const [valor, setValor] = useState(null);
    const [listaOpcoes, setListaOpcoes] = useState([]);
    const [isLoadingQuestao, setIsLoadingQuestao] = useState(false);


    const [boletimVistoriaAtualizado, setBoletimVistoriaAtualizado] = useState(null);

    useEffect(() => {
        setBoletimVistoriaAtualizado(null);
        setIsLoadingQuestao(true);

        formulariovistoria_api.GetOpcoesQuestao(questaoEditar.formularioVistoriaQuestao_Id, stepFormulario).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", "Não foi possivel carregar as opcoes dessa resposta", "error", null);
                return;
            } else {
                // todo do formulario
                setFormularioQuestaoOpcao(result.data);
                //pegando questoes
                let _listaOpcoes = [];
                result.data.formularioVistoriaQuestaoOpcos.map(op => {
                    _listaOpcoes.push(op.valor);
                })
                setListaOpcoes(_listaOpcoes);

                const boletim = boletimVistoria.boletimVistoriaInspecoes.filter(f => f.boletimVistoriaInspecao_Id === stepFormulario)[0];
                const questaovalor = boletim.boletimVistoriaQuestoes.filter(v => v.formularioVistoriaQuestao_Id === questaoEditar.formularioVistoriaQuestao_Id)[0].valor;
                // questao atual do state boletimVistoria
                setValor(questaovalor !== undefined ? questaovalor : result.data.boletimVistoriaQuestos[0].valor);
            }
        }).finally(() => setIsLoadingQuestao(false))
    }, []);

    const closeBtn = (
        <div style={{ fontSize: "20px" }}>
            <i className="fas fa-pencil-alt"></i>
        </div>
    );

    const handleEditResposta = (id, value) => {
        // atualizar campo
        setValor(value);
        // questoes que não foi alteradas
        const novoBoletimvistoria = boletimVistoria.boletimVistoriaInspecoes.map(v => {
            const boletim = { ...v };
            boletim.boletimVistoriaQuestoes = boletim.boletimVistoriaQuestoes.map(q => {
                const novaQuestao = { ...q };
                if (novaQuestao.formularioVistoriaQuestao_Id === questaoEditar.formularioVistoriaQuestao_Id && boletim.boletimVistoriaInspecao_Id === stepFormulario) {
                    novaQuestao.valor = value;
                }
                return novaQuestao;
            })
            return boletim;
        });

        const novo = {
            ...boletimVistoria,
            boletimVistoriaInspecoes: novoBoletimvistoria
        }

        setBoletimVistoriaAtualizado(novo);
    }

    return (
        <Modal isOpen={modalVisibilidade} toggle={setModalVisibilidade} size={"lg"}>
            <ModalHeader toggle={setModalVisibilidade} close={closeBtn}>Editar Resposta</ModalHeader>
            <ModalBody>
                {formularioQuestaoOpcao && !isLoadingQuestao &&
                    <>
                        <InputResposta
                            id={formularioQuestaoOpcao.formularioVistoriaQuestao_Id}
                            typeInput={formularioQuestaoOpcao.tipoValor}
                            label={formularioQuestaoOpcao.identificacao}
                            obrigatorio={formularioQuestaoOpcao.obrigatorio}
                            listaOpcoes={listaOpcoes}
                            valor={valor}
                            handleChangeValor={ (id, value) => handleEditResposta(id, value)}>
                        </InputResposta>
                    </>
                }
            </ModalBody>
            <ModalFooter>
                <Button color="success" onClick={() => {
                    setBoletimVistoria({ ...boletimVistoriaAtualizado });
                    setValor(null);
                    setQuestaoEditar(null);
                    setModalVisibilidade();
                }}>
                    Salvar
                    <i className="ml-2 fas fa-save"></i>
                </Button>
                <Button color="danger" onClick={() => {
                    setBoletimVistoriaAtualizado(null);
                    setValor(null);
                    setQuestaoEditar(null);
                    setModalVisibilidade();
                }}>
                    Cancelar
                    <i className="ml-2 fas fa-times"></i>
                </Button>
            </ModalFooter>
        </Modal>
    )
}